import { State } from '../state';
import { AlarmAcknowledgementState } from '../state/alarm-state';

export const AlarmSelectors = {
    alarmAcknowledgeStarted: (state: State): boolean => state.AlarmAcknowledgement.loading,
    alarmAcknowledgeFailed: (state: State): boolean =>
        state.AlarmAcknowledgement.statusCode >= 400 && state.AlarmAcknowledgement.statusCode <= 409,
    alarmAcknowledgeInfo: (state: State): AlarmAcknowledgementState => state.AlarmAcknowledgement,
};
